module.exports = __webpack_public_path__ + "img/narrow-wake.f3b42090f5dae92a6d90b3139cb960ef.jpg";